<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <path d="M2.02321e-08 2.5338C-0.000174926 1.13425 1.13424 -0.000174766 2.5338 2.01949e-08L11.4645 0.00111651C12.864 0.00129156 13.9987 1.13599 13.9989 2.53555L14 11.4662C14.0002 12.8658 12.8658 14.0002 11.4662 14L2.53555 13.9989C1.136 13.9987 0.00129161 12.864 0.00111645 11.4645L2.02321e-08 2.5338ZM2.53396 1.26706C1.83418 1.26697 1.26697 1.83418 1.26706 2.53396L1.26817 11.4646C1.26826 12.1644 1.83561 12.7317 2.53539 12.7318L11.466 12.7329C12.1658 12.733 12.733 12.1658 12.7329 11.466L12.7318 2.53539C12.7317 1.83561 12.1644 1.26826 11.4646 1.26817L2.53396 1.26706Z" />
  </svg>
</template>
